import styled, { keyframes } from "styled-components";
import { useCompare } from "../context/CompareContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function CompareTray() {
  const { selected, remove, clear } = useCompare();
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);

  if (selected.length === 0) return null;

  return (
    <TrayContainer open={open}>
    <TrayHeader>
    <LeftHeader onClick={() => setOpen(!open)}>
        <Arrow open={open}>▲</Arrow>
        Compare ({selected.length}/5)
    </LeftHeader>

    <HeaderButtons>
        {selected.length >= 2 ? (
        <SmallCompareBtn
            onClick={() =>
            navigate(`/compare?ids=${selected.map((p) => p._id).join(",")}`)
            }
        >
            Compare Now
        </SmallCompareBtn>
        ) : (
        <SmallDisabled>Pick 1 more</SmallDisabled>
        )}

        <RemoveAll onClick={clear}>Clear</RemoveAll>
    </HeaderButtons>
    </TrayHeader>


      {open && (
        <>
          <ItemList>
            {selected.map((p) => (
              <Item key={p._id}>
                <Thumb src={p.imgsrc} />
                <Title>
                  {(p.title || p.description || "Product")
                    .split(" ")
                    .slice(0, 4)
                    .join(" ")}
                </Title>
                <Remove onClick={() => remove(p._id)}>✕</Remove>
              </Item>
            ))}
          </ItemList>

          {/* <ButtonRow>
            {selected.length < 2 ? (
              <DisabledBtn>Select 1 more item</DisabledBtn>
            ) : (
              <CompareBtn
                onClick={() =>
                  navigate(`/compare?ids=${selected.map((p) => p._id).join(",")}`)
                }
              >
                Compare Now
              </CompareBtn>
            )}
          </ButtonRow> */}
        </>
      )}
    </TrayContainer>
  );
}

// ----------------------------------------------------------
// STYLES
// ----------------------------------------------------------

const slideUp = keyframes`
  from { transform: translateY(120px); }
  to { transform: translateY(0); }
`;

const TrayContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #202124;
  color: white;
  animation: ${slideUp} 0.35s ease-out;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.35);
  padding: ${(p) => (p.open ? "1px 14px" : "1px 14px")};
  z-index: 9999;

  @media (max-width: 550px) {
    padding: ${(p) => (p.open ? "1px 12px" : "1px 12px")};
  }
`;


const TrayHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 6px;
  border-bottom: 1px solid #333;
`;

const Arrow = styled.span`
  display: inline-block;
  margin-right: 10px;
  transform: ${(p) => (p.open ? "rotate(0deg)" : "rotate(180deg)")};
  transition: 0.3s;
`;

const RemoveAll = styled.div`
  cursor: pointer;
  color: #ff7c7c;
`;

const ItemList = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  padding: 2px 2px;

  /* Ensure each item stays in ONE ROW */
  white-space: nowrap;

  /* Hide scrollbar (clean UI) */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  height: 40px; /* FIXED HEIGHT */
`;


const Item = styled.div`
  display: flex;
  align-items: center;
  background: #2d2f31;
  padding: 6px 10px;
  border-radius: 6px;
  min-width: 180px;      /* ensures visibility */
  white-space: normal;   /* allow title wrap inside */
  height: 48px;          /* keeps tray slim */
  flex-shrink: 0;        /* required for horizontal scroll */
`;

const Thumb = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin-right: 8px;
`;


const Title = styled.div`
  font-size: 12px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Remove = styled.div`
  margin-left: 8px;
  color: #ff7676;
  cursor: pointer;
  font-size: 18px;
`;

const ButtonRow = styled.div`
  margin-top: 8px;
  text-align: right;
`;

const CompareBtn = styled.button`
  background: #4c8dff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
`;

const DisabledBtn = styled.button`
  background: #555;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  color: #bbb;
`;

const LeftHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 15px;
`;

const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SmallCompareBtn = styled.button`
  background: #4c8dff;
  padding: 6px 12px;
  border: none;
  font-size: 13px;
  border-radius: 6px;
  color: white;
  cursor: pointer;

  @media (max-width: 550px) {
    padding: 8px 14px;
  }
`;

const SmallDisabled = styled.button`
  background: #555;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  color: #bbb;
  border: none;
`;
